import { ReactSVG } from 'react-svg'
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { setCurrentStep, setDataV2, setDynamicAnswer } from '../../onboardingSlice';
import { getImage } from '../../../../utilities/iconResolver';
import { t } from '../../../../utilities/translator';
import { createPortal } from 'react-dom';
import { pushEvent } from '../../../../utilities/analytics';
import { WIZARD_DYNAMIC_QUESTION_ANSWERED } from '../../../../constants/analyticEvents';
import PersonalizationTag from '../../../../components/onboarding/PersonalizationTag';

const FacilitiesSelectionStep = ({ id }: { id: number }) => {
  const facilities = useAppSelector((state) => state.secondaryFilter.data.facilities);
  const selectedFacilities = useAppSelector(state => state.onboarding.formV2.facilities);
  const dispatch = useAppDispatch();
  const footerPortal = document.getElementById('wizard-next-button');

  const handleOptionClick = (id: string) => {
    if (selectedFacilities.includes(id)) {
      dispatch(setDataV2({ facilities: selectedFacilities.filter(item => item !== id) }));
    } else {
      dispatch(setDataV2({ facilities: [id, ...selectedFacilities]}))
    }
  };

  const handleContinueClick = () => {
    dispatch(setCurrentStep(1));
    dispatch(setDynamicAnswer({ id, answer: selectedFacilities }));
    pushEvent(WIZARD_DYNAMIC_QUESTION_ANSWERED, {
      name: 'Facilities',
      answer: selectedFacilities,
    })
  }

  return (
    <div>
      <div className="wizard-step gap-10 wizard-question">
        <div className="text-center">
          <ReactSVG src={getImage('hotel-label.svg')} />
        </div>
        <div className="flex flex-col gap-3 text-center items-center">
          <div className="wizard-step__title">{t('onboarding.facilitiesTitle')}</div>
        </div>
        <div className="flex flex-wrap justify-center gap-2">
          {facilities.map((item) => (
            <PersonalizationTag
              active={selectedFacilities.includes(item.value)}
              key={item.value}
              onClick={() => handleOptionClick(item.value)}
              text={item.label.name}
            />
          ))}
        </div>
      </div>
      {footerPortal ? createPortal(
        <button className="wizard-control-button" onClick={handleContinueClick}>{t('onboarding.continue')}</button>,
        footerPortal
      ) : (
        <div className="wizard-footer">
          <button className="wizard-control-button" onClick={handleContinueClick}>{t('onboarding.continue')}</button>
        </div>
      )}
    </div>
  )
}

export default FacilitiesSelectionStep
